import ReactDOM from 'react-dom'
import { App } from './App'
import './styling/index.css'
import './utils/i18n'

ReactDOM.render(<App />, document.getElementById('root'))
